export const REQUEST_TYPE_LABELS = {
    shift_change: 'Cambio de turno',
    single_class_change: 'Cambio puntual de clase',
    class_material_access: 'Acceso a material de clase',
    temporary_leave: 'Baja temporal',
    data_correction: 'Corrección de datos',
    data_export: 'Exportación de datos',
    data_deletion: 'Eliminación de datos',
    recorded_class: 'Solicitar clase grabada',
    online_class_access: 'Solicitar acceso clases online',
    other: 'Otro',
};
export const REQUEST_STATUS_LABELS = {
    pending: 'Pendiente',
    approved: 'Aprobada',
    rejected: 'Rechazada',
};
//# sourceMappingURL=labels.js.map